import React, { useContext } from "react";
import CircleLoader from "../../../../components/CircleLoader";
import { useSelector } from "react-redux";
import { ThemeContext } from "ThemeContext";
export default function CartLoader() {
  const { currentLanguage } = useSelector(({ main }) => main);
  const { theme, toggleTheme } = useContext(ThemeContext);
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        background: "var(--white)",
        zIndex: 99999999999999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <img
        src={
          currentLanguage === "hy"
            ? theme === "day" ? "https://vlv.am/public/logos/header_hy.svg" : "https://vlv.am/public/logos/header_hy_night.svg"
            : theme === "day" ? "https://vlv.am/public/logos/header_ru.svg" : "https://vlv.am/public/logos/header_ru_night.svg"
        }
        style={{
          width: "170px",
          height: "100px",
          objectFit: "contain",
        }}
       alt="VLV" />
      <CircleLoader containerStyle={{ height: "100px" }} />
    </div>
  );
}
